import { Bot, Handshake, UserRound } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { usePortal } from "../context/PortalContext";

function Responsibility({ title, items, icon: Icon }: { title: string; items: string[]; icon: typeof UserRound }) {
  return <section className="responsibility"><div className="responsibility-title"><Icon size={24} /><h2>{title}</h2></div>{items.length ? <ol>{items.map((item, index) => <li key={item}><span>{String(index + 1).padStart(2, "0")}</span><p>{item}</p></li>)}</ol> : <div className="empty-state">当前轨道尚未声明该角色职责。</div>}</section>;
}

export function RolesPage() {
  const { track } = usePortal();
  if (!track) return <div className="loading-state">正在读取双方职责</div>;
  return (
    <>
      <PageHeading number="06" title="双方职责" description="网页可以承担确定性练习，但不能替你观察、作答和执行；Codex 可以教学与反馈，但不能凭自己的答案单独认证高风险能力。" />
      <div className="role-grid">
        <Responsibility title="你应该做的事" items={track.curriculum.learner_responsibilities} icon={UserRound} />
        <Responsibility title="Codex 应该做的事" items={track.curriculum.coach_responsibilities} icon={Bot} />
      </div>
      <section className="section-block">
        <div className="section-title-row"><div><span className="section-number">06.1</span><h2>共同决定</h2></div><Handshake size={23} /></div>
        <div className="joint-grid">{track.curriculum.joint_decisions.length ? track.curriculum.joint_decisions.map((item, index) => <div key={item}><strong>{String(index + 1).padStart(2, "0")}</strong><p>{item}</p></div>) : <div className="empty-state">当前轨道尚未声明共同决策项。</div>}</div>
      </section>
    </>
  );
}
